import { Skeleton } from '@mui/material'
import React from 'react'

const SupportSkeleton = () => {
    return (
        <>
            {[...Array(3).map((_, index) => (
                <Skeleton key={index} variant="rectangular" width="100%" height={60} />
            ))]}
        </>
    )
}

export default SupportSkeleton